var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMissing = function SvgIconMissing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M3.667 12C3.667 7.4 7.4 3.667 12 3.667S20.333 7.4 20.333 12 16.6 20.334 12 20.334A8.336 8.336 0 0 1 3.667 12M15.5 9.68 14.32 8.5 12 10.82 9.68 8.5 8.5 9.68 10.82 12 8.5 14.32l1.18 1.18L12 13.18l2.32 2.32 1.18-1.18L13.18 12z",
    clipRule: "evenodd"
  })));
};
export default SvgIconMissing;